import { PageHeader } from '@zeiss/lib-components';
import { useTranslation } from 'react-i18next';

import { Result } from './Result';

export const Invitations = () => {
  const { t } = useTranslation(['common']);

  return (
    <>
      <PageHeader headline={t('common:nav.invitations')} />

      <Result />
    </>
  );
};
